import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StepService } from 'services/professional/step/step.service';
import { constants } from 'constants/constants';
import { MessageQueryService } from '@certemy/ui-components';
import { getErrorMessage } from 'utils/helpers';
import { CertificationService } from 'services/certs/certification.service';
import { RegistrationFormField } from 'services/certs/certification.interface';
import { ComputedFrom } from '@certemy/common';
import { isStepSubmitted } from 'utils/step.helpers';

export const PAGES = {
  LOADING: 'LOADING',
  MAIN_START: 'MAIN_START',
  COMPLETE_FORM: 'COMPLETE_FORM',
  CONFIRM_FORM: 'CONFIRM_FORM',
  BACK: 'BACK',
};

@Component({
  selector: 'cm-registration-form-details',
  templateUrl: './registration-form-details.modal.component.html',
  styleUrls: ['./registration-form-details.modal.component.scss'],
})
export class RegistrationFormDetailsComponent implements OnInit {
  @Input() step;
  @Output() toggleMode: EventEmitter<string> = new EventEmitter();
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();
  @Output() screenChange: EventEmitter<string> = new EventEmitter();
  activePage = PAGES.LOADING;
  PAGES = PAGES;
  files: File[] = [];
  constants = constants;
  errorText: string;
  formData: any;
  FIELD_TYPES = constants.FORM_FIELD_TYPE_IDS;
  registrationFormFields: RegistrationFormField[];

  @ComputedFrom('step')
  get isStepSubmitted() {
    return isStepSubmitted(this.step.status_id);
  }

  constructor(
    public activeModal: NgbActiveModal,
    private stepService: StepService,
    private messageQueryService: MessageQueryService,
    private certificationService: CertificationService,
  ) {}

  ngOnInit() {
    this.certificationService.getCertificationRegForm(this.step.certification_id).subscribe((formData) => {
      this.registrationFormFields = formData.fields;

      this.activePage = this.isStepSubmitted ? PAGES.COMPLETE_FORM : PAGES.MAIN_START;
    });
  }

  goToPage(page: string): void {
    this.activePage = page;
  }

  closeModal() {
    this.activeModal.close();
  }

  dismissModal() {
    this.activeModal.dismiss();
  }

  onFormSubmit(data) {
    this.formData = data;
    this.goToPage(PAGES.CONFIRM_FORM);
    this.toggleMode.emit();
  }

  onFormConfirm() {
    this.stepService
      .submitRegistrationForm({
        fields: this.formData,
        stepInstanceId: this.step.step_instance_id,
      })
      .subscribe(
        () => this.completeStep(),
        (err) => this.onRequestFail(err),
      );
  }

  backToCompleteForm(): void {
    this.goToPage(PAGES.COMPLETE_FORM);
    this.toggleMode.emit();
  }

  completeStep() {
    this.messageQueryService.addMessage('Step has been successfully completed');
    this.closeModal();
  }

  onRequestFail(error) {
    const defaultErrorText = `${this.step.name} has failed to get completed. Please, try again`;
    const errorText = getErrorMessage(error, defaultErrorText);
    this.messageQueryService.addErrorMessage(errorText);
  }
}
